<template>
  <div class="home-root">
    <div class="home-box">
      <div class="home-title gsap-box">全场景智能物联网</div>
      <div class="context-three" style="margin-bottom: 30px;">
          <div class="context-three-item gsap-box">
            <div></div>
            <div class="smallB">全程助力</div>
          </div>
          <div class="context-three-item gsap-box">
            <div></div>
            <div class="smallB">智能化</div>
          </div>
          <div class="context-three-item gsap-box">
            <div></div>
            <div class="smallB">安全性</div>
          </div>
          <div class="context-three-item gsap-box">
            <div></div>
            <div class="smallB">无缝链接</div>
          </div>
          <div class="context-three-item gsap-box">
            <div></div>
            <div class="smallB">个性化</div>
          </div>
      </div>
      <div class="home-line gsap-box"></div>
      <div class="home-two gsap-box" style="margin-bottom:10px"><span>人工智能全产业链综合服务平台</span></div>
      <div class="home-three gsap-box">
        <!-- <div class="common-border" style="border-color: rgba(0,0,0,.1);"> -->
          涵盖了各个领域，例如智能家居、智能城市、智能交通、智能工厂、智能农业等。通过物联网技术，我们可以实现设备之间的互联互通，实时监测和控制设备状态，提高效率、降低成本，并为人们提供更加便捷的生活和工作方式。
        <!-- </div> -->
      </div>
      <div class="home-fiv gsap-box">
        <!-- <div class="common-border" style="border-color: rgba(0,0,0,.1);"> -->
          同时，物联网也带来了一些挑战，例如数据安全和隐私保护问题，网络稳定性和可靠性等。因此，在推动物联网的发展过程中，我们需要充分考虑这些问题，并采取相应的措施来保障系统的安全和可靠性.
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'
export default {
  mounted() {
    gsap.from('.gsap-box',{
      x:-(window.innerWidth || document.documentElement.clientWidth),
      duration:1,
      stagger: 0.3, // 按顺序延迟执行每个元素的动画
      ease: "power2.out"
    })
    gsap.from('.gsap-box2',{
      x:-(window.innerWidth || document.documentElement.clientWidth),
      duration:1,
      stagger: 0.7, // 按顺序延迟执行每个元素的动画
      ease: "power2.out"
    })
    gsap.from('.gsap-title',{
      opacity:0,
      duration:3,
      ease: "power2.out"
    })
  },
}
</script>

<style lang="scss" scoped>
  .home-root{
    width: 100%;
    height: 640px;
    background-image: url('../../../assets/internet-bg.png');
    background-size:100% 100%;
    box-sizing: border-box;
    padding-top: 170px;
    // padding-left: 360px;
    .home-box{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      .home-title{
          font-size: 64px;
          font-family: Alibaba_Bold;
          color: #105FF3;
          line-height: 90px;
          margin-bottom: 10px;
      }
      .home-two{
        margin-bottom: 40px;
        span{
          font-size: 32px;
          font-family: Alibaba_Bold;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 45px;
        }
      }
      .home-line{
        height: 54px;
        width: 1px;
        background-color: #fff;
        margin-bottom: 24px;
      }
      .home-three,.home-fiv{
        width: 504px;
        font-size: 14px;
        font-family: Alibaba_Regular;
        color: #EAF1FF;
        line-height: 24px;
        
      }
      .context-three{
          display: flex;
          margin-bottom:30px;

          .context-three-item{
            .small{
                font-size:32px!important;
                font-family: Alibaba_Midum;
                color: #FFFFFF!important;
                background: linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0.8) 80%, rgba(255,255,255,0.5) 100%)!important;
                -webkit-background-clip: text!important;
                -webkit-text-fill-color: transparent!important;
            }
            .smallB{
                font-size: 18px!important;
                font-family: Alibaba_Regular;
                color: #FFFFFF!important;
            }
            display: flex;
            div:nth-child(1){
                margin-top: 11px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: rgba(255,255,255,0.9);
                margin-right: 10px;
            }
            div:nth-child(2){
                font-size: 20px;
                font-family: Alibaba_Midum;
                color: #FFFFFF;
                line-height: 28px;
                margin: 0;
                margin-right: 35px;
            }
          }
      }
      .home-three{
        margin-bottom: 10px;
      }
    }
  }
</style>